module.exports = {
	"header": "E-shop via images - more sites are tapping into the hot trend",
	"date": "2022/10/11",
	"imgSrc": "19.jpg",
	"imgAlt": "E-shop via images - more sites are tapping into the hot trend",
	"ingress": "By: Ehandel.se (in Swedish)",
	"externalLink": "https://www.ehandel.se/e-handla-via-en-bild-tva-nya-sajter-hakar-pa-heta-trenden"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/19/article.json
// module id = 88
// module chunks = 0